import loadable from "@loadable/component";
import pathPatterns from "utils/pathPatterns";

const FriendsList = loadable(() => import("./FriendsList"), { ssr: false });
const Followers = loadable(() => import("./Followers"), { ssr: false });
const Following = loadable(() => import("./Following"), { ssr: false });

export default [
	{
		key: "userFriendsCurrent",
		component: FriendsList,
		path: `/users/:login/friends/:sex(${pathPatterns.sexSingle})?/:page(${pathPatterns.page})?`,
		meta: {
			counterKey: "userFriends",
		},
		exact: true,
	},
	{
		key: "userFollowersCurrent",
		component: Followers,
		path: `/users/:login/friends/followers/:sex(${pathPatterns.sexSingle})?/:page(${pathPatterns.page})?`,
		meta: {
			counterKey: "userFollowers",
		},
		exact: true,
	},
	{
		key: "userFollowingCurrent",
		component: Following,
		path: `/users/:login/friends/following/:sex(${pathPatterns.sexSingle})?/:page(${pathPatterns.page})?`,
		meta: {
			counterKey: "userFollowing",
		},
		exact: true,
	},
];
